// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"AddChannelSubscriptionForm_checkbox__1ZUFF"};